import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { MessageType } from 'dashboard/lib/interfaces/Message';
import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { ThemeSet } from 'dashboard/models/theme-set';
import { showMessage } from 'dashboard/redux/actions/messages';
import { addThemeSet, removeThemeSet, setThemeSets } from 'dashboard/redux/slices/theme-sets';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint, ApiModel } from 'lib/interfaces/api';

export interface ThemeSetsFilterParams {
  sortParams: SortParams;
  omni: string | undefined;
  abortSignal?: AbortSignal;
}

export const loadThemeSets =
  (filters: ThemeSetsFilterParams): DashboardThunkAction =>
  async (dispatch) => {
    const { sortParams, omni, abortSignal } = filters;

    const params = {
      filter: {
        omni,
      },
      ...(sortParams
        ? {
            sort: `${sortParams.shouldSortDescending ? '-' : ''}${sortParams.sort}`,
          }
        : {}),
      signal: abortSignal,
    };

    const { data: themeSets } = await SessionClientDashboard.listResource<ThemeSet>(
      ApiEndpoint.ThemeSet,
      params,
    );

    dispatch(setThemeSets(themeSets));
  };

export const createThemeSet =
  (themeSetName: string): DashboardThunkAction<Promise<void>> =>
  async (dispatch) => {
    const { data: themeSet } = await SessionClientDashboard.postResourceCreate<ThemeSet>({
      type: ApiModel.ThemeSet,
      attributes: {
        name: themeSetName,
      },
    });
    dispatch(showMessage('Successfully created Theme Set', MessageType.Success));
    dispatch(addThemeSet(themeSet));
  };

export const cloneThemeSet =
  (themeSet: ThemeSet): DashboardThunkAction<Promise<void>> =>
  async (dispatch) => {
    const { data: newThemeSet } = await SessionClientDashboard.postResourceAction<ThemeSet>(
      {
        type: ApiModel.ThemeSet,
        id: themeSet.id,
      },
      'clone',
    );
    dispatch(showMessage('Successfully duplicated Theme Set', MessageType.Success));
    dispatch(addThemeSet(newThemeSet));
  };

export const archiveThemeSet =
  (themeSet: ThemeSet): DashboardThunkAction<Promise<void>> =>
  async (dispatch) => {
    const { data: updatedThemeSet } = await SessionClientDashboard.deleteResource<ThemeSet>(
      ApiEndpoint.ThemeSet,
      themeSet.id,
    );
    dispatch(showMessage('Successfully archived Theme Set', MessageType.Success));
    dispatch(removeThemeSet(updatedThemeSet));
  };
